<template>
  <section
    :id="section.id"
    class="content-section"
  >
    <div class="container">
      <div class="small-content">
        <div class="top-text-block">
          <div
            :class="[
              'top-text',
              section.is_visible ? 'fade-in' : 'fade-out',
            ]"
          >
            <h2 class="section-title small">
              {{ getContent('section_4.block_1_title') }}
            </h2>
            <p class="content-text">
              {{ getContent('section_4.block_1_description') }}
            </p>
          </div>
          <div
            :class="[
              'top-text',
              section.is_visible ? 'fade-in' : 'fade-out',
            ]"
            :style="{ transitionDelay: getFadeTransitionDelay(1) }"
          >
            <h2 class="section-title small">
              {{ getContent('section_4.block_2_title') }}
            </h2>
            <p class="content-text">
              {{ getContent('section_4.block_2_description') }}
            </p>
          </div>
        </div>
        <div
          :class="section.is_visible ? 'fade-in' : 'fade-out'"
          :style="{ transitionDelay: getFadeTransitionDelay(2) }"
        >
          <h2 class="section-title small">
            {{ getContent('section_4.block_3_title') }}
          </h2>
          <p class="content-text">
            {{ getContent('section_4.block_3_description') }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContentSectionFour',
  data: () => ({
    section: {
      id: contentSectionId.four,
      is_visible: true,
    },
  }),
  mounted() {
    this.section.is_visible = false
    initObserver(this.section)
  },
};
</script>

<style lang="scss" scoped>
.content-section {
  margin-top: 124px;

  .section-title {
    text-align: start;
    margin-bottom: 32px;
  }

  .top-text-block {
    display: flex;
    margin-bottom: 64px;
    justify-content: space-between;

    .top-text {
      max-width: 442px;
    }
  }

  .block-margin {
    margin-bottom: 64px;
  }
}

@media only screen and (max-width: $sm) {
  .content-section {
    margin-top: 64px;

    .top-text-block {
      display: block;

      .top-text {
        max-width: 100%;
        margin-bottom: 64px;
      }
    }
  }
}
</style>
